import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import Linechart from "../../components/DashboardComponents/LineChart";
import CardTab from "../../components/DashboardComponents/CardTab/CardTab";
import CampaignTable from "../../components/DashboardComponents/CampaignTable";

import { Container, Wrapper, TableWrapper } from "./DashboardStyles";
import {
  PageHeader,
  PageStack,
  Panel,
  SectionHeader,
  StatCard,
  StatGrid,
} from "../../components/common/ui";
import theme from "../../theme";
import { getUserProfile } from '../../redux/slices/userSlice';
import { getTopBoard } from '../../redux/slices/dashboardSlice';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { topBoard } = useSelector((state) => state.dashboard);

  const userRole = localStorage.getItem('userRole');
  const isSupport = userRole === 'SUPPORT';

  useEffect(() => {
    if (!isSupport) {
      dispatch(getUserProfile());
      dispatch(getTopBoard());
    }
  }, [dispatch, isSupport]);

  return (
    <Container>
      <PageStack>
        {!isSupport && (
          <PageHeader>
            <div>
              <h1>Hey, {user.data?.firstName || 'there'}</h1>
              <p>Here's how your campaigns are performing today.</p>
            </div>
            <div className="actions">
              <Link className="ghost" to="/reports">View reports</Link>
              <Link className="primary" to="/create-campaign">+ Create campaign</Link>
            </div>
          </PageHeader>
        )}

        {!isSupport && (
          <StatGrid>
            <StatCard
              label="Total campaigns"
              value={topBoard?.totalCampaigns}
              hint="Across all advertisers"
              accent={theme.color.brand}
              glyph="◎"
            />
            <StatCard
              label="Total advertisers"
              value={topBoard?.totalAdvertisers}
              hint="Registered on ClickCircle"
              accent={theme.chart[2]}
              glyph="◇"
            />
            <StatCard
              label="Total publishers"
              value={topBoard?.totalPublishers}
              hint="Distributing your ads"
              accent={theme.chart[1]}
              glyph="⬡"
            />
          </StatGrid>
        )}

        <Panel $flush>
          <Linechart />
        </Panel>

        {!isSupport && (
          <Wrapper>
            <CardTab title="Performing advertisers" advertisers />
            <CardTab title="Performing publishers" publishers />
          </Wrapper>
        )}

        <Panel $flush>
          <TableWrapper>
            <SectionHeader
              title="Best performing campaigns"
              subtitle="Track and manage your live ads"
              inset
              divided
            >
              <Link className="ghost" to="/campaigns">See more</Link>
              <Link className="primary" to="/create-campaign">+ Create campaign</Link>
            </SectionHeader>
            <CampaignTable />
          </TableWrapper>
        </Panel>
      </PageStack>
    </Container>
  );
};

export default Dashboard;
